'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RequestQuote = function RequestQuote(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("rect", {
    width: "24",
    height: "24",
    fill: "url(#pattern0)"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, React__default["default"].createElement("use", {
    xlinkHref: "#image0_1534_107441",
    transform: "scale(0.0208333)"
  })), React__default["default"].createElement("image", {
    id: "image0_1534_107441",
    width: "48",
    height: "48",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAbtJREFUaEPtmT1OBDEMhd9yHOgXWioORA8LPQ2ngY4SDsB1AHm1lqxoJn6TZCZekbSTcd5nO87fDmfedmeuHwOgdwTZCOwBvAK4biT4AOCphS0G4BLAd4vBEhtNIBiANwB3KwCIyWoIBuDXiGf6z7GK2MeJj1UQjKC1AaoiEQWgGCISQBHElgCS/5LvXls0JyICLIpEVAAaIjIABbElADOWzo8fdu1hjLZaB7zJa7/TYw6AjFulHD6cvj+TJVTNhYiArfuydWbWgK4AIjjdrGmKWo+qyItM9LpEYEpkbuLm5t8AKClp1mu59JjK8zRS3SPAlOdceg2A2hTySqZ3I9E9At624QPAbbQyKlcvcgXDtnBlVLe/OQC70IUE8LzP5jbbj7rcpY156gGwtth+A8A63Z6i5oJh8z7cHPhXmznvfNBlDqQpIacxXZFFsF19vWh1AUjz3t5Gex4PsRtNRaQR8bxesv/avIwSS8WxS4gUYsVO9WsK8Gke95akQQ2Apt8XgJvSg7X+Jy+TAtGjiXiBmG3s0e8KwMuKj32pwHcA98zrKAugAyztXxo1OlW3ElQK4v43AFwXrdzhDyXwejGutvMzAAAAAElFTkSuQmCC"
  })));
};

var RequestQuote$1 = iconStyles()(RequestQuote);

module.exports = RequestQuote$1;
